export * from "./upsert-rights.schema";
